import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import TableContent from "../../TableContent";

export default function Daesung() {
  const [isLoading, setIsLoading] = useState(false);

  const [data, setData] = useState([]);
  const handleDuplicate = (dt) => {
    // 동일한 데이터 제거
    let temp = {};
    const reversed = (arr, asc) =>
      arr.sort((a, b) => {
        return asc
          ? Date.parse(a.date) - Date.parse(b.date)
          : Date.parse(b.date) - Date.parse(a.date);
      });

    const reversedData = reversed(dt, true).filter((item) => {
      const { date, ...prep } = item;
      if (JSON.stringify(temp) === JSON.stringify(prep)) {
        return false;
      } else {
        temp = { ...prep };
        return true;
      }
    });

    return reversed(reversedData, false);
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const res = await axios.get("/api/hanwoori");
      setData(handleDuplicate(res.data));
      setIsLoading(false);
    })();
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "일자",
        accessor: "date",
        disableFilters: true,
      },
      {
        Header: "합계",
        accessor: "total",
        disableFilters: true,
        disableSortBy: true,
      },
      {
        Header: "서울",
        accessor: "seoul",
        disableFilters: true,
        disableSortBy: true,
      },
      {
        Header: "경기",
        accessor: "gyeonggi",
        disableFilters: true,
        disableSortBy: true,
      },
      {
        Header: "인천",
        accessor: "incheon",
        disableFilters: true,
        disableSortBy: true,
      },
      {
        Header: "강원",
        accessor: "gangwon",
        disableFilters: true,
        disableSortBy: true,
      },
      {
        Header: "대전",
        accessor: "daejeon",
        disableFilters: true,
        disableSortBy: true,
      },
      {
        Header: "대구",
        accessor: "daegu",
        disableFilters: true,
        disableSortBy: true,
      },
      {
        Header: "울산",
        accessor: "ulsan",
        disableFilters: true,
        disableSortBy: true,
      },
      {
        Header: "부산",
        accessor: "busan",
        disableFilters: true,
        disableSortBy: true,
      },
      {
        Header: "경북",
        accessor: "gyeongsangbukdo",
        disableFilters: true,
        disableSortBy: true,
      },
      {
        Header: "경남",
        accessor: "gyeongsangnamdo",
        disableFilters: true,
        disableSortBy: true,
      },
      {
        Header: "광주",
        accessor: "gwangju",
        disableFilters: true,
        disableSortBy: true,
      },
      {
        Header: "전북",
        accessor: "jeollabukdo",
        disableFilters: true,
        disableSortBy: true,
      },
      {
        Header: "전남",
        accessor: "jeollanamdo",
        disableFilters: true,
        disableSortBy: true,
      },
      {
        Header: "제주",
        accessor: "jeju",
        disableFilters: true,
        disableSortBy: true,
      },
      {
        Header: "세종",
        accessor: "sejong",
        disableFilters: true,
        disableSortBy: true,
      },
    ],
    []
  );

  return (
    <TableContent
      isLoading={isLoading}
      columns={columns}
      data={data}
      disableControlPanel={true}
    />
  );
}
